import { createReduxStore } from '../../../shared/utils/redux';
import { IApplicationState } from '../../../shared/types/redux';
import { IApplicationContext } from '../../../shared/types/ICustomContextParams';

export function createApplicationState(context: IApplicationContext) {
  const { config, httpApi, logger } = context;

  const _context = { httpApi, config, logger };

  const initialState = config.getStrict<IApplicationState>('initialState');

  return createReduxStore(initialState, true, _context);
}
